"use client";

import React from "react";
import Action from "./Action";
import { Mail as MailIcon } from "@churchofjesuschrist/eden-icons";
import buildURL from "./build-url";
import useValueOnMount from "./use-value-on-mount";
import { jsx as _jsx } from "react/jsx-runtime";
const useMailShareUrl = ({
  body,
  subject,
  to = ""
} = {}) => buildURL(`mailto:${to}`, {
  search: {
    body: useValueOnMount(() => body || window.location.href),
    subject: useValueOnMount(() => subject || document.title)
  }
});

/**
 * A button that triggers an email to be sent via the OS's chosen email client, to be used within an `ActionBar`.
 * @param {object} props - The component props
 * @param {string} [props.label] - Hidden text label for the button.
 * @param {string} [props.to] - The "to" address(es).
 * @param {string} [props.subject] - The email subject line. Defaults to `document.title` once mounted.
 * @param {string} [props.body] - The email body. Defaults to `window.location.href` once mounted.
 * @returns {React.ReactElement} The Mail component
 */
const Mail = ({
  body,
  subject,
  to = "",
  label = "Mail",
  ...props
}) => /*#__PURE__*/_jsx(Action, {
  ...props,
  href: useMailShareUrl({
    body,
    subject,
    to
  }),
  Icon: MailIcon,
  label: label
});
Mail.displayName = "Mail";
export default Mail;